import { Tooltip, Typography } from '@mui/material';

export function ValueWithValidity(props: { value: string; isValid: boolean }) {
  return (
    <Tooltip title={props.isValid ? undefined : 'Invalid'}>
      <Typography
        variant="inherit"
        color={props.isValid ? undefined : 'error.main'}
        component="span"
        display="inline-block"
        maxWidth="100%"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {props.value}
      </Typography>
    </Tooltip>
  );
}
